import { clsx } from 'clsx';
import { Title } from '../Title';
import * as style from './Сonvenient.css';
import { CONVENIENT } from 'shared/constants/convenient';
import { useDeviceType } from '@cian/ui-kit';
import { ConvenientItem } from '../ConvenientItem';
import { SLIDER_SETTINGS } from 'shared/constants/sliderSettings';
import { CustomSlider } from '../Slider/Slider';

export const Convenient: React.FC = () => {
  const device = useDeviceType();

  const content = CONVENIENT.map((item, index) => <ConvenientItem key={index} {...item} />);

  return (
    <div
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title']}>
        <Title>С нами удобнее и надёжнее</Title>
      </div>
      <div className={style['table']}>
        <div className={style['header']}>
          <div className={style['empty']} />
          <div className={style['headers']}>
            <div className={style['logo']} />
            <div className={style['header-text']}>Самостоятельно</div>
          </div>
        </div>
        <div className={style['list']}>
          {device === 'phone' ? (
            <CustomSlider {...SLIDER_SETTINGS} customPaging={() => <div className={style['paging']} />}>
              {content}
            </CustomSlider>
          ) : (
            content
          )}
        </div>
      </div>
    </div>
  );
};
